import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { PoliticalPartyDBContext } from "./PoliticalPartyDBContext";
import { useContext, useEffect, useState } from "react";
import PoliticalPartyService from "../../services/PoliticalPartyService";
import { Button } from "primereact/button";
import { AppDB } from "../../App";
import ScreenLoader from "../../componets/ScreenLoader";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { politicalPartyUsersService } from "../../services/PoliticalPartyUsersService";
import PoliticalPartyRequirements from "./PoliticalPartyRequirements";

export default function PoliticalPartyUsers({ header = null }) {
	var { selectedParty, contestationPeriodID } = useContext(PoliticalPartyDBContext);

	var [loading, setLoading] = useState(true);
	var [refresh, setRefresh] = useState(false);
	var [canEnableButton, setCanEnableButton] = useState(false);
	var [users, setUsers] = useState([]);
	var { toast } = useContext(AppDB);

	var politicalPartyService = new PoliticalPartyService();

	useEffect(() => {
		setLoading(true);
		politicalPartyService.getUsersByID(selectedParty.politicalPartyID,contestationPeriodID).then((data) => {
			setUsers(data);
			setLoading(false);
		});
	}, [refresh]);

	const confirmDeleteUser = (event, row) => {
		confirmDialog({
			target: event.currentTarget,
			message: "Are you sure you want to proceed?",
			icon: "pi pi-exclamation-triangle",
			accept: () => {
				// setLoading(true);
				politicalPartyUsersService.delete(row.externalUserID).then((res) => {
					setLoading(false);
					if (res.success) {
						setRefresh(!refresh);
						toast.show({
							severity: "success",
							detail: "User Deactivated",
							life: 2500
						});
					} else {
						toast.show({
							severity: "error",
							detail: res.message,
							life: 2500
						});
					}
				});
			},
			reject: () => {}
		});
	};

	function createUser() {
		setLoading(true);
		politicalPartyService
			.createUser({
				politicalPartyID: selectedParty.politicalPartyID,
				isCandidate: false
			})
			.then((res) => {
				setLoading(false);
				if (res.success) {
					setRefresh(!refresh);
					toast.show({
						severity: "success",
						detail: "User created",
						life: 2500
					});
				} else {
					toast.show({
						severity: "error",
						detail: res.message,
						life: 2500
					});
				}
			});
	}

	return (
		<>
			<ConfirmDialog />
			<ScreenLoader visible={loading} />
			<PoliticalPartyRequirements  setSecretaryGeneralEmail={setCanEnableButton} isSecretary_General_Email={true}  />
			<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
				<div>
					<Button
						disabled={!canEnableButton}
						label="Create User"
						loading={loading}
						onClick={() => {
							createUser();
						}}
						className="p-button-success mr-3"
					/>
					<br />

					{!canEnableButton && (
						<div style={{ color: "red" }} className="mt-2">
							The Secretary-General email is required for creating users.{" "}
						</div>
					)}
				</div>
			</div>

			<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center my-2">
				{header !== null && <h5>{header}</h5>}
			</div>
			<DataTable
				className="remove-border"
				size="small"
				scrollable={true}
				value={users}
				dataKey="id"
				loading={loading}
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column field="email" header="Email" sortable body={(e) => e?.email}></Column>
				<Column field="displayName" header="Username" sortable body={(e) => e?.displayName}></Column>
				<Column
					field="active"
					header="Status"
					body={(e) =>
						e?.active ? (
							<Button label="Active" style={{ textAlign: "center", height: "30px" }} className="p-button-success p-button-rounded" />
						) : (
							<Button label="Not Active" style={{ textAlign: "center", height: "30px" }} className="p-button-danger p-button-rounded" />
						)
					}
					sortable
				></Column>
				<Column
					field="actions"
					header="Actions"
					body={(e) => (
						<>
							<Button
							disabled={!e?.active}
								onClick={(event) => confirmDeleteUser(event, e)}
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi- pi-times"}
								className="p-button-danger p-button-rounded mr-2"
								tooltip="Click to De-activate"
							/>
						</>
					)}
				></Column>
			</DataTable>
		</>
	);
}
